import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const Card = styled(Stack)(() => ({
  background: 'white',
  width: '100%',
  height: '100%',
}));
